import { render, staticRenderFns } from "./TableLoans.vue?vue&type=template&id=913ca628"
import script from "./TableLoans.vue?vue&type=script&lang=js"
export * from "./TableLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports